import React, { ComponentType, FunctionComponent, ReactElement, ReactNode, SVGProps } from 'react'
import clsx from 'clsx'
import Tooltip from '../tooltip/Tooltip'
import { useAppSelector } from '../../hooks/useStore'

type IProps = {
  Icon: FunctionComponent<SVGProps<SVGElement>>
  title?: string
  classes?: string
  onClickIcon?: () => void
}

const MenuIcon = ({ Icon, title, classes, onClickIcon }: IProps) => {
  const { isToggle } = useAppSelector((state) => state.dashboardUi.sidebar)
  return (
    <div
      className={clsx('group relative flex items-center mb-1', `${classes}`)}
      onClick={onClickIcon}
    >
      <>
        {Icon && <Icon />}
        {isToggle && <Tooltip title={title} />}
      </>
    </div>
  )
}

export default MenuIcon
